import React from 'react';
import { ManagedDropdown } from '../../ManagedDropdown/ManagedDropdown';
import { Button } from '../buttonBar/Button';
import { Icon, Icons } from '@starrez/starryui';
import { strings } from '../../../.localisation';
import { OptionCheckbox, OptionScroller, SelectionOption } from '../../lists/SelectionOption';

interface IPaginationPerPageProps {
    value: number;
    onClick: (value: number) => void;
}

export const PaginationPerPage = ({ value, onClick }: IPaginationPerPageProps) => (
    <ManagedDropdown
        placement="top-end"
        width="146px"
        modifiers={[
            {
                name: 'offset',
                options: {
                    offset: [0, 4],
                },
            },
        ]}
        manager={(onClick, { visible }) => (
            <Button
                variant="small"
                aria-expanded={visible}
                aria-pressed={visible}
                ariaLabel="Items Per Page"
                onClick={onClick}
                title="Items Per Page"
            >
                <Icon Height="20px" Width="20px" Icon={Icons.CaretDown} />
            </Button>
        )}
    >
        <SelectionOption focusFirstElement>
            <OptionScroller>
                <OptionCheckbox
                    aria-label={strings.Label_25_PerPage}
                    caption={strings.Label_25_PerPage}
                    onClick={() => onClick(25)}
                    checked={value === 25}
                    closeOnClick
                />

                <OptionCheckbox
                    aria-label={strings.Label_50_PerPage}
                    caption={strings.Label_50_PerPage}
                    onClick={() => onClick(50)}
                    checked={value === 50}
                    closeOnClick
                />

                <OptionCheckbox
                    aria-label={strings.Label_100_PerPage}
                    caption={strings.Label_100_PerPage}
                    onClick={() => onClick(100)}
                    checked={value === 100}
                    closeOnClick
                />

                <OptionCheckbox
                    aria-label={strings.Label_250_PerPage}
                    caption={strings.Label_250_PerPage}
                    onClick={() => onClick(250)}
                    checked={value === 250}
                    closeOnClick
                />

                <OptionCheckbox
                    aria-label={strings.Label_500_PerPage}
                    caption={strings.Label_500_PerPage}
                    onClick={() => onClick(500)}
                    checked={value === 500}
                    closeOnClick
                />
            </OptionScroller>
        </SelectionOption>
    </ManagedDropdown>
);
